export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ13.b465bb9e.mp3";